// price-filter-jp.js  — JPY の価格フィルター入力を “常に整数円” に正規化
document.addEventListener('DOMContentLoaded', () => {
  // ① 日本円のときだけ動かす
  const isJPY =
    (window.Shopify && Shopify.currency && Shopify.currency.active === 'JPY') ||
    (document.documentElement.lang || '').toLowerCase().includes('ja');
  if (!isJPY) return;

  // ② よくあるセレクタをまとめてカバー（テーマ差吸収）
  const SEL =
    'input[name="filter.v.price.gte"], input[name="filter.v.price.lte"], ' +
    '.price-range input[type="number"], .price-range input[type="text"], ' +
    '[data-filter-type="price"] input';

  const inputs = Array.from(document.querySelectorAll(SEL));
  if (!inputs.length) return;

  // ③ “整数のみ”に整える関数（カンマ/小数/全角数字などを除去）
  const norm = (el) => {
    if (!el) return;
    const raw = String(el.value || '')
      // 全角 → 半角
      .replace(/[０-９]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 0xfee0))
      // 数字以外を除去（カンマやドットを含め全部）
      .replace(/[^\d]/g, '');
    if (!raw) {
      el.value = '';
      return;
    }
    // 先頭0は自然に消える（parseInt）
    const v = parseInt(raw, 10);
    el.value = isFinite(v) ? String(v) : '';
  };

  // ④ “小数点が入らない”ブラウザヒント（iOSキーボード等）
  inputs.forEach((el) => {
    el.setAttribute('inputmode', 'numeric');
    el.setAttribute('pattern', '[0-9]*');
    el.setAttribute('step', '1');
    // テーマ側の書式化後に上書きできるよう、blur/changeで最終正規化
    el.addEventListener('blur', () => norm(el), true);
    el.addEventListener('change', () => norm(el), true);
    el.addEventListener('input', () => {
      // 入力途中で “6.6” のような文字が入っても即除去
      const before = el.value;
      norm(el);
      // キャレットが末尾に飛ぶのが嫌ならここはコメントアウトでもOK
      if (el.value !== before) el.setSelectionRange(el.value.length, el.value.length);
    }, { passive: true });
  });

  // ⑤ 送信直前に最終チェック（URLクエリが小数/カンマ化される事故を防ぐ）
  document.querySelectorAll('form').forEach((f) => {
    f.addEventListener('submit', () => {
      Array.from(f.querySelectorAll(SEL)).forEach(norm);
    }, true);
  });
});
